import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const SkuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 4h9l9 9-8 8-10-10z" />
      <circle cx="8" cy="8" r="1.5" />
      <path d="m12 12 3 3" />
    </g>
  </SvgIcon>
)

export default SkuIcon
